import { fetchAll } from '@/api/dictionary';
import { toTree } from '@/utils/tree';
import types from '../types';

const state = {
  dictionaries: [],
  dictionaryTree: []
};

const getters = {
  getEnumsByParentValue: state => parentValue => {
    return (state.dictionaryTree.find(dictionary => dictionary.value === parentValue) || {}).children || [];
  },
  getfilingLevelEnums: (state, getters) => {
    return getters.getEnumsByParentValue('filing_level');
  },
  knowledgeCategoryEnums: (state, getters) => {
    return getters.getEnumsByParentValue('knowl_category');
  },
  getSystemTypeEnums: (state, getters) => {
    return getters.getEnumsByParentValue('system_type');
  }
};

const mutations = {
  [types.SET_DICTIONARIES](state, dictionaries) {
    state.dictionaries = dictionaries;
    state.dictionaryTree = toTree(dictionaries);
  }
};

const actions = {
  fetchDictionaries({ commit }) {
    this.tableLoading = true;
    return fetchAll()
      .then(res => {
        const dictionaries = res.data.data || [];
        commit(types.SET_DICTIONARIES, dictionaries);
        this.tableLoading = false;
      })
      .catch(error => {
        this.tableLoading = false;
        Promise.reject(error);
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/dictionary.js